module.exports = __webpack_public_path__ + "static/media/icon_bootstrap.584d9f32.png";